import { motion } from "framer-motion";

const rows = [
  { label: "General Consultation", note: "Diagnosis & X-ray" },
  { label: "Specialist Consultation", note: "Endodontics / Prosthodontics" },
  { label: "Root Canal Treatment", note: "Anterior / Molar" },
  { label: "Zirconia Crown", note: "Monolithic, shade-matched" },
  { label: "Dental Implant", note: "Titanium root + crown, digitally planned" },
  { label: "Clear Aligners", note: "Full arch, mild–moderate cases" },
  { label: "Porcelain Laminates", note: "Per tooth, hand-shaped" },
];

export default function Pricing() {
  return (
    <section
      id="pricing"
      data-testid="pricing-section"
      className="relative py-28 md:py-40 bg-porcelain border-b border-bone"
    >
      <div className="mx-auto max-w-[1440px] px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-12 gap-6 md:gap-10 mb-16 md:mb-24">
          <div className="col-span-12 md:col-span-5">
            <div className="flex items-center gap-4 mb-8">
              <span className="w-10 h-px bg-ink" />
              <span className="eyebrow">The Index</span>
            </div>
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
              className="font-serif font-light text-4xl md:text-5xl lg:text-6xl leading-[0.95] tracking-tight"
              data-testid="pricing-heading"
              style={{ color: "#4A3520" }}
            >
              Every discipline, <span className="italic" style={{ color: "#1E5AA8" }}>indexed.</span>
            </motion.h2>
          </div>

          <div className="col-span-12 md:col-span-6 md:col-start-7 md:pt-4">
            <p className="text-ink/70 text-base font-light leading-relaxed max-w-[44ch]">
              A full list of the treatments practised at the clinic. Each plan is finalised only
              after a specialist consultation — quotes are shared honestly, in person.
            </p>
          </div>
        </div>

        <div className="border-t border-ink">
          {rows.map((r, i) => (
            <motion.div
              key={r.label}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: i * 0.04 }}
              className="group grid grid-cols-12 gap-4 items-baseline border-b border-bone py-6 md:py-8 hover:bg-white/40 transition-colors duration-500 px-2"
              data-testid={`price-row-${i}`}
            >
              <div className="col-span-1 hidden md:block eyebrow">{String(i + 1).padStart(2, "0")}</div>
              <div className="col-span-11 md:col-span-8">
                <div className="font-serif text-2xl md:text-3xl font-light text-ink leading-tight">{r.label}</div>
                <div className="text-ink/60 text-sm md:text-[13px] mt-2 font-light tracking-wide">{r.note}</div>
              </div>
              <div className="col-span-12 md:col-span-3 text-right eyebrow text-ink/40 group-hover:text-taupe transition-colors duration-500 hidden md:block">
                Enquire →
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
